export default "__VITE_ASSET__BU8wSE4Q__"